<template>
  <div id="app">     
    <Hexometer/>
  </div>
</template>

<script>
import Hexometer from './components/Hexometer.vue'

export default {
  name: 'App',
  components: {
    Hexometer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color:#f8f8fa;
  margin-top: 60px;
}
</style>
